import { Link } from '@inertiajs/react'
import { Upload } from 'lucide-react'

export default function EmptyState() {
    return (
        <div className="text-center py-12">
            <Upload className="mx-auto h-12 w-12 text-gray-400"/>
            <h3 className="mt-2 text-sm font-semibold text-gray-900">No uploads yet</h3>
            <p className="mt-1 text-sm text-gray-500">
                Get started by uploading your first organization data file.
            </p>
            <div className="mt-6">
                <Link
                    href="/admin/organization_uploads/new"
                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                >
                    <Upload className="w-4 h-4 mr-2"/>
                    Upload Organization Data
                </Link>
            </div>
        </div>
    )
}